import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import { showToast } from '@deeptrue-frontend/ui';

import { useFormatMessage } from 'components/IntlProvider';
import { Dashboard } from 'components/Layout';
import ROUTES from 'consts/routing';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import TemplatesList from 'components/Templates/TemplatesList';
import { BriefingsReducerType } from 'store/modules/briefings/briefings.types';
import api from 'api/api';
import AdminMenu from 'components/AdminMenu/AdminMenu';

const { connect, selectors, actions } = StoreProvider;

interface ExtendedTemplateProps {
  templates: BriefingsReducerType['list'];
  setTemplates: (payload: any) => void;
  clearTemplates: () => void;
}

const BriefingTemplates = ({
  history,
  templates,
  setTemplates,
  clearTemplates,
  location,
}: RouteComponentProps & ExtendedTemplateProps) => {
  const parsedSearch = queryString.parse(location.search);
  const t = useFormatMessage();

  useEffect(() => {
    if (parsedSearch.action === 'template_created') {
      showToast({
        type: 'info',
        title: t('dashboard.templates.created', 'Template created'),
      });
    }
    if (parsedSearch.action === 'template_edited') {
      showToast({
        type: 'info',
        title: t('dashboard.templates.edited', 'Template edited'),
      });
    }
    if (parsedSearch.action === 'template_deleted') {
      showToast({
        type: 'info',
        title: t('dashboard.templates.deleted', 'Template deleted'),
      });
    }

    api.resources.getBriefings(parsedSearch).then(({ data }) => {
      setTemplates(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, location.key]);

  useEffect(() => {
    return () => {
      clearTemplates();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeTemplate = (id: number) => {
    api.resources
      .removeBriefing({ id })
      .then(() =>
        history.push(
          `${ROUTES.ADMIN.TEMPLATES.BRIEFINGS.MAIN}?action=template_deleted`
        )
      )
      .catch(() => {
        showToast({
          type: 'error',
          title: t(
            'errors.toast.general',
            'Something went wrong, please contact administrator'
          ),
        });
      });
  };

  const getPageNumber = () => {
    if (parsedSearch.offset && !Array.isArray(parsedSearch.offset)) {
      return parseInt(parsedSearch.offset, 10) / 20;
    }

    return 0;
  };

  return (
    <Dashboard title="Briefing Templates" location={location}>
      <AdminMenu />

      <Grid container>
        <TemplatesList
          list={templates.results}
          count={templates.count}
          currentPage={getPageNumber()}
          removeTemplate={removeTemplate}
          singleUrl={ROUTES.ADMIN.TEMPLATES.BRIEFINGS.MAIN}
          createUrl={ROUTES.ADMIN.TEMPLATES.BRIEFINGS.CREATE}
        />
      </Grid>
    </Dashboard>
  );
};

export default connect(
  (state) => ({
    templates: selectors.briefings.list(state),
  }),
  {
    setTemplates: actions.briefings.setBriefings,
    clearTemplates: actions.briefings.clearBriefings,
  }
)(BriefingTemplates);
